import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar, { MobileSidebar, MobileTopBar } from "./Sidebar";
import { useAuth } from "../lib/AuthContext";
import { useSite } from "../lib/SiteContext";

function LoadingScreen({ msg = "Loading…" }) {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex items-center gap-3 text-muted-foreground text-sm">
        <div className="w-4 h-4 rounded-full border-2 border-zinc-700 border-t-foreground animate-spin" />
        {msg}
      </div>
    </div>
  );
}

export default function Layout() {
  const { user } = useAuth();
  const { sites, loaded, currentSite } = useSite();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (user === null) return <LoadingScreen msg="Authenticating…" />;
  if (user === false) return <Navigate to="/login" replace />;
  if (!loaded) return <LoadingScreen msg="Loading sites…" />;
  if (sites.length === 0) return <Navigate to="/onboarding" replace />;
  if (!currentSite) return <LoadingScreen msg="Selecting site…" />;

  return (
    <div className="min-h-screen bg-background topo-bg flex">
      <Sidebar />
      <MobileSidebar open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <MobileTopBar onOpen={() => setDrawerOpen(true)} />
        <main className="flex-1 min-w-0 px-4 sm:px-6 lg:px-10 py-6 lg:py-8">
          <div className="max-w-7xl mx-auto fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
